/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
import React, { useState } from 'react';
import Stack from '@mui/material/Stack';
import './index.css';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import WriteExperience from './WriteExperience';
import ReviewComponent from '../Reviews/ReviewComponent';

function CustomerContainer({ 
  experienceGetData,baseURL, setPage, typePage,
}) {
  const {
    linkid, templateid, contactid, type, 
  } = useParams();

  const [reviewPage, setReviewPage] = useState(1);

  const handleReviewActivity = async (value) => {
    const formData = {
      contact_id: contactid,
      activity_action_name: 'clicked',
      performed_on: value,
      sent_via: type,
      template_type: experienceGetData?.template?.template_type_,
      company_id: experienceGetData?.template?.company_id,
      account_id: null,
    };
    const res = await axios.post(`${baseURL}/activity/add-activity`, formData);
    console.log('handleReviewActivity res', res);
    if (value === 'Google' && experienceGetData?.template?.review_site_1_platform === 'Google') {
      window.open(experienceGetData?.template?.review_site_1_url, '_blank');
    }
    if (value === 'Facebook' && experienceGetData?.template?.review_site_2_platform === 'Facebook') {
      window.open(experienceGetData?.template?.review_site_2_url, '_blank');
    }
  };

  return (
    <div>
      {reviewPage === 1 && (
        <ReviewComponent 
          getData={experienceGetData} 
          handleReviewActivity={handleReviewActivity} 
          setPage={setReviewPage}
          page={reviewPage}
          typePage={typePage}
        />
      )}
    </div>
  );
}

export default CustomerContainer;
